import script from "./BookedSessions.vue?vue&type=script&setup=true&lang=js"
export * from "./BookedSessions.vue?vue&type=script&setup=true&lang=js"

import "./BookedSessions.vue?vue&type=style&index=0&id=26fe530b&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fe530b"]])

export default __exports__